/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import {
  StrapiListingPageContext,
} from 'src/infrastructure/gatsby/node/create-pages/strapi-listing-pages/types';
import {
  StrapiArticles,
} from 'src/infrastructure/gatsby/types/strapi-articles';
import BlogList from '../blog-list';
import NewsList from '../news-list';

export interface ListComponent {
  articles: StrapiArticles;
  totalPages: StrapiListingPageContext['totalPages'];
  currentPage: StrapiListingPageContext['currentPage'];
}

interface IProps {
  articles: StrapiArticles;
  pageContext: StrapiListingPageContext;
}

const ListingBuilder: FC<IProps> = ({ articles, pageContext }) => {
  let Component;
  switch (pageContext.type) {
    case 'blog-list': {
      Component = BlogList as FC<ListComponent>;
      break;
    }
    case 'news-list': {
      Component = NewsList as FC<ListComponent>;
      break;
    }
    default:
      return null;
  }

  return (
    <div data-test="article-list">
      <Component
        articles={articles}
        totalPages={pageContext.totalPages}
        currentPage={pageContext.currentPage}
      />
    </div>
  );
};

export default ListingBuilder;
